
// utils/profile.translate.js
export const translations= {
  es: {
    profileTitle: "Perfil del Operador",
    loadingProfile: "Cargando perfil...",
    error: "Error",
    noOperatorId: "No hay id_operator en localStorage",
    noToken: "No hay token en localStorage",
    errorFetchingData: "Error al obtener datos del operador",
    errorUpdating: "Error al actualizar el operador",
    errorFetchingUpdated: "Error al obtener datos actualizados",
    operatorNotFound: "No se encontró el operador",
    loginToViewProfile: "Por favor inicia sesión para ver tu perfil.",
    
    // Estados
    active: "Activo",
    pending: "Pendiente",
    inactive: "Inactivo",
    
    // Placeholders
    namePlaceholder: "Nombre",
    lastName1Placeholder: "Primer Apellido",
    lastName2Placeholder: "Segundo Apellido",
    phonePlaceholder: "Teléfono",
    locationPlaceholder: "Ubicación",
    descriptionPlaceholder: "Descripción",
    
    // Botones y acciones
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    
    // Campos
    description: "Descripción",
    registrationDate: "Fecha de Registro",
    verifiedAccount: "Cuenta verificada",
    
    // Idiomas
    spanish: "Español",
    english: "Inglés",
    invalidPhone: "Número de teléfono no válido para Costa Rica",
    phoneFormatHint: "Formato válido: 8888-8888, 50688888888 o +506 8888-8888",
    phonePlaceholder: "Ej: 8888-8888 o +506 8888-8888",
    invalidName: "El nombre solo puede contener letras y espacios (2-50 caracteres)",
    invalidLastName: "El apellido solo puede contener letras y espacios (2-50 caracteres)",
  },
  en: {
    profileTitle: "Operator Profile",
    loadingProfile: "Loading profile...",
    error: "Error",
    noOperatorId: "No id_operator in localStorage",
    noToken: "No token in localStorage",
    errorFetchingData: "Error fetching operator data",
    errorUpdating: "Error updating operator",
    errorFetchingUpdated: "Error fetching updated data",
    operatorNotFound: "Operator not found",
    loginToViewProfile: "Please log in to view your profile.",
    
    // Estados
    active: "Active",
    pending: "Pending",
    inactive: "Inactive",
    
    // Placeholders
    namePlaceholder: "Name",
    lastName1Placeholder: "First Last Name",
    lastName2Placeholder: "Second Last Name",
    phonePlaceholder: "Phone",
    locationPlaceholder: "Location",
    descriptionPlaceholder: "Description",
    
    // Botones y acciones
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    
    // Campos
    description: "Description",
    registrationDate: "Registration Date",
    verifiedAccount: "Verified account",
    
    // Idiomas
    spanish: "Spanish",
    english: "English",
    invalidPhone: "Invalid phone number for Costa Rica",
    phoneFormatHint: "Valid format: 8888-8888, 50688888888 or +506 8888-8888",
    phonePlaceholder: "Ex: 8888-8888 or +506 8888-8888",
     invalidName: "Name can only contain letters and spaces (2-50 characters)",
    invalidLastName: "Last name can only contain letters and spaces (2-50 characters)",
  }
};